import { render, staticRenderFns } from "./CedexDependenciesSidebar.vue?vue&type=template&id=247c0ae6&scoped=true&"
import script from "./CedexDependenciesSidebar.vue?vue&type=script&lang=js&"
export * from "./CedexDependenciesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CedexDependenciesSidebar.vue?vue&type=style&index=0&id=247c0ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c0ae6",
  null
  
)

export default component.exports